import { render, staticRenderFns } from "./ChooseTeam.vue?vue&type=template&id=57536642&scoped=true&"
import script from "./ChooseTeam.vue?vue&type=script&lang=js&"
export * from "./ChooseTeam.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTeam.vue?vue&type=style&index=0&id=57536642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57536642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
